import styled from 'styled-components/macro';
import { COLORS } from 'utils/styles/colors';
import { Link } from 'react-router-dom';
import { deviceMax } from 'utils/styles/breakpoints';
import { FONTS, FONT_FAMILY } from 'utils/styles/fonts';
import { FLEX_CONTAINER } from 'utils/styles/flex';

export const RegisterFormWrapper = styled.div`
  ${FLEX_CONTAINER.FlexCenterColumn}
  position: relative;
`;

export const RegisterBlock = styled.div`
  width: 450px;
  padding: 16px;
  background: linear-gradient(
    155.67deg,
    rgba(255, 255, 255, 0.59) -7.08%,
    rgba(255, 255, 255, 0.13) 110.41%
  );
  border: 1px solid rgba(15, 66, 90, 0.33);
  box-shadow: 0px 4px 24px -1px rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(20px);
  border-radius: 12px;
  margin-top: 160px;
  margin-bottom: 100px;

  @media only screen and ${deviceMax.desktop} {
    width: 400px;
  }

  @media only screen and ${deviceMax.mobileL} {
    width: 290px;
  }
`;

export const TitlePage = styled.div`
  ${FONTS.font24}
  color: ${COLORS.mainColor};
  ${FONT_FAMILY.FontBold}
  text-align: center;
  text-transform: capitalize;
  margin-top: 20px;

  @media only screen and ${deviceMax.mobileL} {
    ${FONTS.font20}
  }
`;

export const CloseIcon = styled.img`
  ${FLEX_CONTAINER.FlexRow}

  @media only screen and ${deviceMax.mobileL} {
    width: 12px;
  }
`;

export const CloseIconLink = styled(Link)`
  position: absolute;
  top: 20px;
  right: 30px;

  @media only screen and ${deviceMax.desktop} {
    width: 14px;
    right: 20px;
    top: 20px;
  }
`;

export const RegisterFormBlock = styled.form`
  padding: 20px;
  position: relative;
`;

export const StyledButtonContainer = styled.div`
  margin-top: 30px;
`;

export const OtherSuggestionBlock = styled.div`
  width: 100%;
  height: 200px;
`;

export const SuggestionBlock = styled.div`
  margin-top: 20px;
  width: 100%;
`;

export const SuggestingToLogWith = styled.span`
  ${FONT_FAMILY.FontExtraBold}
  ${FONTS.font16}
  color: ${COLORS.mainColor};

  @media only screen and ${deviceMax.desktop} {
    ${FONTS.font12}
  }
`;

export const RememberText = styled.span``;

export const RegistrationErrorMessage = styled.p`
  ${FONT_FAMILY.FontRegular};
  ${FONTS.font12};
  color: ${COLORS.red};
  padding-top: 8px;
  height: 14px;
`;
